"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.dropdownWidth = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var _elements = require("../../styles/elements");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var dropdownWidth = (0, _util.rem)(240);
exports.dropdownWidth = dropdownWidth;
var icon = /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(20), ";height:", (0, _util.rem)(20), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:icon;"));
var base = process.env.NODE_ENV === "production" ? {
  name: "f224cz",
  styles: "display:inline-flex;position:relative;flex-direction:column"
} : {
  name: "1ji4jb6-base",
  styles: "display:inline-flex;position:relative;flex-direction:column;label:base;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var item = function item(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;justify-content:space-between;padding:", theme.spacing['5'], " ", theme.spacing['7'], ";min-height:", (0, _util.rem)(40), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:item;"));
};

var footer = function footer(theme) {
  return /*#__PURE__*/(0, _react.css)(item(theme), " padding-top:", theme.spacing['6'], ";padding-bottom:", theme.spacing['6'], ";svg{", icon, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:footer;"));
};

var footerWithBtns = function footerWithBtns(theme) {
  return /*#__PURE__*/(0, _react.css)("padding-top:", theme.spacing['7'], ";padding-bottom:", theme.spacing['7'], ";button+button{margin-left:", theme.spacing['5'], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:footerWithBtns;"));
};

var header = function header(theme) {
  return /*#__PURE__*/(0, _react.css)(footer(theme), " padding-top:", theme.spacing['7'], ";padding-bottom:", theme.spacing['7'], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:header;"));
};

var dropdownContainer = function dropdownContainer(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.dropdown.bg, ";color:", theme.color.dropdown.text, ";font-size:", theme.fontSize.base, ";position:absolute;width:100%;border-radius:", (0, _util.rem)(6), ";opacity:0;transition:opacity 0.3s ease-in-out;pointer-events:none;overflow-x:hidden;overflow-y:auto;max-height:", (0, _util.rem)(200), ";z-index:1001;" + (process.env.NODE_ENV === "production" ? "" : ";label:dropdownContainer;"));
};

var autoWidth = process.env.NODE_ENV === "production" ? {
  name: "3abrc0",
  styles: "width:auto"
} : {
  name: "wk0u0h-autoWidth",
  styles: "width:auto;label:autoWidth;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var autoH = process.env.NODE_ENV === "production" ? {
  name: "1btqjzz",
  styles: "overflow-y:unset;max-height:unset"
} : {
  name: "7r5xb0-autoH",
  styles: "overflow-y:unset;max-height:unset;label:autoH;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var minWidth = /*#__PURE__*/(0, _react.css)("min-width:", dropdownWidth, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:minWidth;"));
var trigger = process.env.NODE_ENV === "production" ? {
  name: "1nob2mz",
  styles: "&:focus{outline:none;}"
} : {
  name: "1luvcss-trigger",
  styles: "&:focus{outline:none;};label:trigger;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var visible = process.env.NODE_ENV === "production" ? {
  name: "1esllos",
  styles: "opacity:1;pointer-events:initial"
} : {
  name: "jggudb-visible",
  styles: "opacity:1;pointer-events:initial;label:visible;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var description = function description(theme) {
  return /*#__PURE__*/(0, _react.css)(item(theme), ";", _elements.text.styles.textTiny(theme), " background-color:", theme.color.dropdown.descriptionBg, ";margin:-", theme.spacing['6'], " -", theme.spacing['7'], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:description;"));
};

var bigAvartar = /*#__PURE__*/(0, _react.css)("margin-left:-", (0, _util.rem)(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:bigAvartar;"));
var styles = {
  base: base,
  visible: visible,
  description: description,
  bigAvartar: bigAvartar,
  item: item,
  footer: footer,
  footerWithBtns: footerWithBtns,
  header: header,
  trigger: trigger,
  dropdownContainer: dropdownContainer,
  minWidth: minWidth,
  autoH: autoH,
  autoWidth: autoWidth
};
exports.styles = styles;
//# sourceMappingURL=Dropdown.styles.js.map